import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "useAuth – the simplest way to add authentication to your React app",
  "description": "",
  "published": "2019-08-09T00:00:00.000Z",
  "redirect_from": ["/blog/useauth-the-simplest-way-to-add-authentication-to-your-react-app/swizec/9179"],
  "categories": "Front End, Technical",
  "hero": "./img/techletter.app-screenshot-1565368070812.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <blockquote>
      <p parentName="blockquote">{`Omg I just built the simplest way to add authentication to your React app. Should seriously open source it`}</p>
      <p parentName="blockquote">{`Handles everything for you. Users, login forms, redirects, sharing state between components. Everything`}</p>
    </blockquote>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/Swizec/status/1156446593874157569"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "126.00896860986548%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'504\\'%20viewBox=\\'0%200%20400%20504\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M32%2021c-6%203-10%2011-7%2016v3l1%201%202%202%201%202%201-2-2-4c0-1%201-2%203-2%203-1%205-5%203-8-1-2-1-2%201-2s2%201%202%203l1%205c1%202-2%204-4%203l-2%201c-1%202%201%204%202%202h3c2%200%202-1%202-2%200-2%204-4%205-3l-2%206c-2%204-3%205-6%205l-3%201h4c3%201%205%201%208-1%204-1%205-3%201-4l-2-2c0-2%204-5%206-4l1-1%202-2c2-2-1-9-4-10l-4-3c-3-3-8-3-13%200m-5%2041c-4%203-2%2011%204%2011%205%200%207-8%203-11l-3-2-4%202m30%20176c-2%202-2%20134%200%20136l5%201c2%200%203%200%202%201-2%200-1%201%203%204%2012%2010%205%209%20133%209%20124%200%20120%200%20130-7%208-5%208-6%206-6-1-1%200-1%202-1l5-1c2-2%202-134%200-136s-284-2-286%200m146%20206l-3%202c-6%207%204%2016%2010%2010%206-5%200-15-7-12m35%201v2l-1%201c-2%200-3%202-2%205%203%208%2014%206%2014-2%200-6-5-9-11-6m54%201c-4%203-4%209%200%208h2l-1%201c-2%200-1%202%202%203%204%201%207-1%206-5l1-3%201-2h-2c-1%201-1%201-1-1s0-3-3-3c-2%200-4%200-5%202\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/b0cec0239e9ad8914df95a68a98f29bf/ca0a1/techletter.app-screenshot-1565368070812.webp 223w", "/static/b0cec0239e9ad8914df95a68a98f29bf/75680/techletter.app-screenshot-1565368070812.webp 445w", "/static/b0cec0239e9ad8914df95a68a98f29bf/0ba47/techletter.app-screenshot-1565368070812.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/b0cec0239e9ad8914df95a68a98f29bf/e92b6/techletter.app-screenshot-1565368070812.png 223w", "/static/b0cec0239e9ad8914df95a68a98f29bf/e66bf/techletter.app-screenshot-1565368070812.png 445w", "/static/b0cec0239e9ad8914df95a68a98f29bf/6af66/techletter.app-screenshot-1565368070812.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/b0cec0239e9ad8914df95a68a98f29bf/6af66/techletter.app-screenshot-1565368070812.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`So I did 😎`}</p>
    <h2 {...{
      "id": "announcing-useauth"
    }}>{`Announcing useAuth`}</h2>
    <p><a parentName="p" {...{
        "href": "https://github.com/Swizec/useAuth"
      }}><inlineCode parentName="a">{`useAuth`}</inlineCode></a>{` is the simplest way to add authentication to your React app. Handles everything for you – user management, cookies, sharing state between components, login forms, everything you need to get started.`}</p>
    <p>{`A lot of that is handled through Auth0 right now and I'm very open to adding other providers. I like Auth0 because it's free for way more users than I'll ever have and it isn't Google 😛`}</p>
    <p>{`You can try it out here 👉 `}<a parentName="p" {...{
        "href": "https://gatsby-useauth-example.now.sh/"
      }}>{`https://gatsby-useauth-example.now.sh/`}</a></p>
    <p>{`See the code here 👉 `}<a parentName="p" {...{
        "href": "https://github.com/Swizec/useAuth"
      }}>{`https://github.com/Swizec/useAuth`}</a></p>
    <p>{`Example code here 👉 `}<a parentName="p" {...{
        "href": "https://github.com/Swizec/useAuth/tree/master/examples/useauth-gatsby"
      }}>{`https://github.com/Swizec/useAuth/tree/master/examples/useauth-gatsby`}</a></p>
    <p><a parentName="p" {...{
        "href": "https://gatsby-useauth-example.now.sh"
      }}><img parentName="a" {...{
          "src": "/1392ca5a499998a2ae634b3518d7a4a4/KunEemN.gif",
          "alt": null
        }}></img></a></p>
    <h2 {...{
      "id": "how-to-use-useauth"
    }}>{`How to use useAuth`}</h2>
    <p><a parentName="p" {...{
        "href": "https://github.com/Swizec/useAuth"
      }}><inlineCode parentName="a">{`useAuth`}</inlineCode></a>{` is designed to be quick to setup. You'll need an Auth0 account with an app domain and client id.`}</p>
    <h3 {...{
      "id": "1-install-the-hook"
    }}>{`1. Install the hook`}</h3>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=null&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%24%20yarn%20add%20react-use-auth"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "302px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "61.88340807174888%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'248\\'%20viewBox=\\'0%200%20400%20248\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M45%2066l-2%203v56c0%2054%200%2057%202%2059s38%203%20156%203c117%200%20153-1%20155-3s2-5%202-59V68l-2-2-3-2H47l-2%202m47%2021c-4%205-1%2013%205%2013%203%200%208-5%208-8%200-7-9-10-13-5m29-2c-5%202-6%207-3%2011%205%207%2015%200%2012-7%200-2-5-5-6-5l-3%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/0d175883045b43954dbf1e870aecd6f6/ca0a1/techletter.app-screenshot-1565368072267.webp 223w", "/static/0d175883045b43954dbf1e870aecd6f6/7cc02/techletter.app-screenshot-1565368072267.webp 302w"],
                "sizes": "(max-width: 302px) 100vw, 302px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/0d175883045b43954dbf1e870aecd6f6/e92b6/techletter.app-screenshot-1565368072267.png 223w", "/static/0d175883045b43954dbf1e870aecd6f6/5f1d2/techletter.app-screenshot-1565368072267.png 302w"],
                "sizes": "(max-width: 302px) 100vw, 302px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/0d175883045b43954dbf1e870aecd6f6/5f1d2/techletter.app-screenshot-1565368072267.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Downloads from npm, adds to your package.json, etc. You can use `}<inlineCode parentName="p">{`npm`}</inlineCode>{` as well.`}</p>
    <h3 {...{
      "id": "2-set-up-authprovider"
    }}>{`2. Set up AuthProvider`}</h3>
    <p>{`useAuth uses an `}<inlineCode parentName="p">{`AuthProvider`}</inlineCode>{` component to configure the Auth0 client and share state between components. It's using React context with a reducer behind the scenes, but that's an implementation detail.`}</p>
    <p>{`I recommend adding this around your root component. In Gatsby that's done in `}<inlineCode parentName="p">{`gatsby-browser.js`}</inlineCode>{` and `}<inlineCode parentName="p">{`gatsby-ssr.js`}</inlineCode>{`. Yes `}<inlineCode parentName="p">{`useAuth`}</inlineCode>{` is built so it doesn't break server-side rendering. ✌️`}</p>
    <p>{`But of course server-side "you" will always be logged out.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%2F%2F%20gatsby-browser.js%0A%0Aimport%20React%20from%20%22react%22%0Aimport%20%7B%20navigate%20%7D%20from%20%22gatsby%22%0A%0Aimport%20%7B%20AuthProvider%20%7D%20from%20%22react-use-auth%22%0A%0Aexport%20const%20wrapRootElement%20%3D%20(%7B%20element%20%7D)%20%3D%3E%20(%0A%09%3CAuthProvider%0A%09%20%20navigate%3D%7Bnavigate%7D%0A%09%20%20auth0_domain%3D%22useauth.auth0.com%22%0A%09%20%20auth0_client_id%3D%22GjWNFNOHq1ino7lQNJBwEywa1aYtbIzh%22%0A%09%3E%0A%09%20%20%7Belement%7D%0A%09%3C%2FAuthProvider%3E%0A)"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "550px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "82.95964125560539%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'332\\'%20viewBox=\\'0%200%20400%20332\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M24%2036c-2%202-2%20259%200%20261s350%202%20352%200%202-259%200-261-350-2-352%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/d3e698631eff9602a5d02064378fe420/ca0a1/techletter.app-screenshot-1565368071557.webp 223w", "/static/d3e698631eff9602a5d02064378fe420/75680/techletter.app-screenshot-1565368071557.webp 445w", "/static/d3e698631eff9602a5d02064378fe420/12b65/techletter.app-screenshot-1565368071557.webp 550w"],
                "sizes": "(max-width: 550px) 100vw, 550px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/d3e698631eff9602a5d02064378fe420/e92b6/techletter.app-screenshot-1565368071557.png 223w", "/static/d3e698631eff9602a5d02064378fe420/e66bf/techletter.app-screenshot-1565368071557.png 445w", "/static/d3e698631eff9602a5d02064378fe420/dd45a/techletter.app-screenshot-1565368071557.png 550w"],
                "sizes": "(max-width: 550px) 100vw, 550px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/d3e698631eff9602a5d02064378fe420/dd45a/techletter.app-screenshot-1565368071557.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p><inlineCode parentName="p">{`<AuthProvider>`}</inlineCode>{` creates a context, sets up a state reducer, initializes an Auth0 client and so on. Everything you need for authentication to work in your whole app :)`}</p>
    <p>{`The API takes a couple config options:`}</p>
    <ol>
      <li parentName="ol"><inlineCode parentName="li">{`navigate`}</inlineCode>{` – your navigation function, used for redirects. I've tested with Gatsby, but anything should work`}</li>
      <li parentName="ol"><inlineCode parentName="li">{`auth0_domain`}</inlineCode>{` – from your Auth0 app`}</li>
      <li parentName="ol"><inlineCode parentName="li">{`auth0_client_id`}</inlineCode>{` – from your Auth0 app`}</li>
      <li parentName="ol"><inlineCode parentName="li">{`auth0_params`}</inlineCode>{` – an object that lets you overwrite any of the default Auth0 client parameters`}</li>
    </ol>
    <p><em parentName="p">{`PS: even though Auth doesn't do anything server-side, useAuth will throw errors during build, if its context doesn't exist`}</em></p>
    <h4 {...{
      "id": "default-auth0-params"
    }}>{`Default Auth0 params`}</h4>
    <p>{`By default `}<inlineCode parentName="p">{`useAuth`}</inlineCode>{`'s Auth0 client uses these params:`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=const%20params%20%3D%20%7B%0A%20%20%20%20domain%3A%20auth0_domain%2C%0A%20%20%20%20clientID%3A%20auth0_client_id%2C%0A%20%20%20%20redirectUri%3A%20%60%24%7Bcallback_domain%7D%2Fauth0_callback%60%2C%0A%20%20%20%20audience%3A%20%60https%3A%2F%2F%24%7Bauth0_domain%7D%2Fapi%2Fv2%2F%60%2C%0A%20%20%20%20responseType%3A%20%22token%20id_token%22%2C%0A%20%20%20%20scope%3A%20%22openid%20profile%20email%22%0A%7D%3B"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "526px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "59.64125560538116%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'238\\'%20viewBox=\\'0%200%20400%20238\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M25%2038c-2%202-1%20161%201%20163%201%201%2029%202%20174%202s173-1%20174-2c2-2%203-161%201-163S27%2036%2025%2038\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/156f5c54b791b199e2a203fe00947a8a/ca0a1/techletter.app-screenshot-1565368071495.webp 223w", "/static/156f5c54b791b199e2a203fe00947a8a/75680/techletter.app-screenshot-1565368071495.webp 445w", "/static/156f5c54b791b199e2a203fe00947a8a/9752a/techletter.app-screenshot-1565368071495.webp 526w"],
                "sizes": "(max-width: 526px) 100vw, 526px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/156f5c54b791b199e2a203fe00947a8a/e92b6/techletter.app-screenshot-1565368071495.png 223w", "/static/156f5c54b791b199e2a203fe00947a8a/e66bf/techletter.app-screenshot-1565368071495.png 445w", "/static/156f5c54b791b199e2a203fe00947a8a/2d7ab/techletter.app-screenshot-1565368071495.png 526w"],
                "sizes": "(max-width: 526px) 100vw, 526px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/156f5c54b791b199e2a203fe00947a8a/2d7ab/techletter.app-screenshot-1565368071495.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p><inlineCode parentName="p">{`domain`}</inlineCode>{` and `}<inlineCode parentName="p">{`clientID`}</inlineCode>{` come from your props.`}</p>
    <p><inlineCode parentName="p">{`redirectUri`}</inlineCode>{` is set to use the `}<inlineCode parentName="p">{`auth0_callback`}</inlineCode>{` page on the current domain. Auth0 redirects here after users login so you can set cookies and stuff. `}<inlineCode parentName="p">{`useAuth`}</inlineCode>{` will handle this for you ✌️`}</p>
    <p><inlineCode parentName="p">{`audience`}</inlineCode>{` is set to use api/v2. I know this is necessary but honestly have been copypasting it through several of my projects.`}</p>
    <p><inlineCode parentName="p">{`responseType`}</inlineCode>{` same here. I copy paste this from old projects so I figured it's a good default.`}</p>
    <p><inlineCode parentName="p">{`scope`}</inlineCode>{` you need `}<inlineCode parentName="p">{`openid`}</inlineCode>{` for social logins and to be able to fetch user profiles after authentication. Profile and Email too. You can add more via the `}<inlineCode parentName="p">{`auth0_params`}</inlineCode>{` override.`}</p>
    <h3 {...{
      "id": "3-create-the-callback-page"
    }}>{`3. Create the callback page`}</h3>
    <p>{`Auth0 and most other authentication providers use OAuth. That requires redirecting your user to `}<em parentName="p">{`their`}</em>{` login form. After login, the provider redirects the user back to `}<em parentName="p">{`your`}</em>{` app.`}</p>
    <p>{`Any way of creating React pages should work, here's what I use for Gatsby.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%2F%2F%20src%2Fpages%2Fauth0_callback%0A%0Aimport%20React%2C%20%7B%20useEffect%20%7D%20from%20%22react%22%0A%0Aimport%20%7B%20useAuth%20%7D%20from%20%22react-use-auth%22%0Aimport%20Layout%20from%20%22..%2Fcomponents%2Flayout%22%0A%0Aconst%20Auth0CallbackPage%20%3D%20()%20%3D%3E%20%7B%0A%20%20const%20%7B%20handleAuthentication%20%7D%20%3D%20useAuth()%0A%20%20useEffect(()%20%3D%3E%20%7B%0A%20%20%20%20handleAuthentication()%0A%20%20%7D%2C%20%5B%5D)%0A%0A%20%20return%20(%0A%20%20%20%20%3CLayout%3E%0A%20%20%20%20%20%20%3Ch1%3E%0A%20%20%20%20%20%20%20%20This%20is%20the%20auth%20callback%20page%2C%20you%20should%20be%20redirected%20immediately.%0A%20%20%20%20%20%20%3C%2Fh1%3E%0A%20%20%20%20%3C%2FLayout%3E%0A%20%20)%0A%7D%0A%0Aexport%20default%20Auth0CallbackPage"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "718px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "81.1659192825112%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'325\\'%20viewBox=\\'0%200%20400%20325\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M19%2028a6953%206953%200%20001%20270h361l1-136V28l-182-1-181%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/679e8a981d599d99bea2da8d9a4dcd9b/ca0a1/techletter.app-screenshot-1565368071694.webp 223w", "/static/679e8a981d599d99bea2da8d9a4dcd9b/75680/techletter.app-screenshot-1565368071694.webp 445w", "/static/679e8a981d599d99bea2da8d9a4dcd9b/7d0c9/techletter.app-screenshot-1565368071694.webp 718w"],
                "sizes": "(max-width: 718px) 100vw, 718px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/679e8a981d599d99bea2da8d9a4dcd9b/e92b6/techletter.app-screenshot-1565368071694.png 223w", "/static/679e8a981d599d99bea2da8d9a4dcd9b/e66bf/techletter.app-screenshot-1565368071694.png 445w", "/static/679e8a981d599d99bea2da8d9a4dcd9b/57dc1/techletter.app-screenshot-1565368071694.png 718w"],
                "sizes": "(max-width: 718px) 100vw, 718px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/679e8a981d599d99bea2da8d9a4dcd9b/57dc1/techletter.app-screenshot-1565368071694.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`The goal is to load a page, briefly show some text, and run the `}<inlineCode parentName="p">{`handleAuthentication`}</inlineCode>{` method from `}<inlineCode parentName="p">{`useAuth`}</inlineCode>{` on page load.`}</p>
    <p>{`That method will create a cookie in local storage with your user's information and redirect back to homepage. Redirecting to other post-login pages currently isn't supported but is a good idea now that I thought of it 🤔`}</p>
    <p><strong parentName="p"><em parentName="strong">{`PS: Make sure you add `}<inlineCode parentName="em">{`<domain>/auth0_callback`}</inlineCode>{` as a valid callback URL in your Auth0 config`}</em></strong></p>
    <h3 {...{
      "id": "4-enjoy-useauth"
    }}>{`4. Enjoy useAuth`}</h3>
    <p><a parentName="p" {...{
        "href": "https://gatsby-useauth-example.now.sh"
      }}><img parentName="a" {...{
          "src": "/1392ca5a499998a2ae634b3518d7a4a4/KunEemN.gif",
          "alt": null
        }}></img></a></p>
    <p>{`You're ready to use `}<inlineCode parentName="p">{`useAuth`}</inlineCode>{` for authentication in your React app.`}</p>
    <p>{`Here's a login button for example:`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%2F%2F%20src%2Fpages%2Findex.js%0A%0Aconst%20Login%20%3D%20()%20%3D%3E%20%7B%0A%20%20const%20%7B%20isAuthenticated%2C%20login%2C%20logout%20%7D%20%3D%20useAuth()%0A%0A%20%20if%20(isAuthenticated())%20%7B%0A%20%20%20%20return%20%3CButton%20onClick%3D%7Blogout%7D%3ELogout%3C%2FButton%3E%0A%20%20%7D%20else%20%7B%0A%20%20%20%20return%20%3CButton%20onClick%3D%7Blogin%7D%3ELogin%3C%2FButton%3E%0A%20%20%7D%0A%7D"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "534px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "68.60986547085201%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'275\\'%20viewBox=\\'0%200%20400%20275\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M25%2037l-1%20101c0%2098%200%20100%202%20101l174%201%20174-1c2-1%202-3%202-101l-1-101c-2-2-348-2-350%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/9314ba6476e3cf378ec7aa287cbe40f0/ca0a1/techletter.app-screenshot-1565368071687.webp 223w", "/static/9314ba6476e3cf378ec7aa287cbe40f0/75680/techletter.app-screenshot-1565368071687.webp 445w", "/static/9314ba6476e3cf378ec7aa287cbe40f0/29722/techletter.app-screenshot-1565368071687.webp 534w"],
                "sizes": "(max-width: 534px) 100vw, 534px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/9314ba6476e3cf378ec7aa287cbe40f0/e92b6/techletter.app-screenshot-1565368071687.png 223w", "/static/9314ba6476e3cf378ec7aa287cbe40f0/e66bf/techletter.app-screenshot-1565368071687.png 445w", "/static/9314ba6476e3cf378ec7aa287cbe40f0/a07a7/techletter.app-screenshot-1565368071687.png 534w"],
                "sizes": "(max-width: 534px) 100vw, 534px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/9314ba6476e3cf378ec7aa287cbe40f0/a07a7/techletter.app-screenshot-1565368071687.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p><inlineCode parentName="p">{`isAuthenticated`}</inlineCode>{` is a method that checks if the user's cookie is still valid. `}<inlineCode parentName="p">{`login`}</inlineCode>{` and `}<inlineCode parentName="p">{`logout`}</inlineCode>{` trigger their respective actions.`}</p>
    <p>{`You can even say hello to your users`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%2F%2F%20src%2Fpages%2Findex.js%0A%0Aconst%20IndexPage%20%3D%20()%20%3D%3E%20%7B%0A%20%20const%20%7B%20isAuthenticated%2C%20user%20%7D%20%3D%20useAuth()%0A%0A%20%20return%20(%0A%20%20%20%20%3CLayout%3E%0A%20%20%20%20%20%20%3CSEO%20title%3D%22Home%22%20%2F%3E%0A%20%20%20%20%20%20%3Ch1%3EHi%20%7BisAuthenticated()%20%3F%20user.name%20%3A%20%22people%22%7D%3C%2Fh1%3E"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "582px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "56.95067264573991%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'227\\'%20viewBox=\\'0%200%20400%20227\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M23%2035c-2%203-1%20158%200%20159%202%202%20352%202%20354%200%201-1%202-156%200-159-1-3-353-3-354%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/38d842652b39f504ebd4985d24e58d42/ca0a1/techletter.app-screenshot-1565368071620.webp 223w", "/static/38d842652b39f504ebd4985d24e58d42/75680/techletter.app-screenshot-1565368071620.webp 445w", "/static/38d842652b39f504ebd4985d24e58d42/f6aeb/techletter.app-screenshot-1565368071620.webp 582w"],
                "sizes": "(max-width: 582px) 100vw, 582px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/38d842652b39f504ebd4985d24e58d42/e92b6/techletter.app-screenshot-1565368071620.png 223w", "/static/38d842652b39f504ebd4985d24e58d42/e66bf/techletter.app-screenshot-1565368071620.png 445w", "/static/38d842652b39f504ebd4985d24e58d42/7c1cd/techletter.app-screenshot-1565368071620.png 582w"],
                "sizes": "(max-width: 582px) 100vw, 582px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/38d842652b39f504ebd4985d24e58d42/7c1cd/techletter.app-screenshot-1565368071620.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Check `}<inlineCode parentName="p">{`isAuthenticated`}</inlineCode>{` then use the user object. Simple as that.`}</p>
    <hr></hr>
    <p>{`You can try it out here 👉 `}<a parentName="p" {...{
        "href": "https://gatsby-useauth-example.now.sh/"
      }}>{`https://gatsby-useauth-example.now.sh/`}</a></p>
    <p>{`See the code here 👉 `}<a parentName="p" {...{
        "href": "https://github.com/Swizec/useAuth"
      }}>{`https://github.com/Swizec/useAuth`}</a></p>
    <p>{`Example code here 👉 `}<a parentName="p" {...{
        "href": "https://github.com/Swizec/useAuth/tree/master/examples/useauth-gatsby"
      }}>{`https://github.com/Swizec/useAuth/tree/master/examples/useauth-gatsby`}</a></p>
    <hr></hr>
    <p>{`Hope you like it :)`}</p>
    <p>{`Cheers,`}<br parentName="p"></br>{`
`}{`~Swizec`}</p>
    <p>{`PS: we'll be using and talking about useAuth in more depth at my `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/wanna-come-hang-out-in-barcelona/swizec/9175"
      }}>{`Barcelona workshop in September`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      